import React, { FC } from 'react';
import FilterIcon from '../../../../images/common/filter-black.svg';
import ColumnIcon from '../../../../images/common/column-black.svg';
import ExportIcon from '../../../../images/common/export-grey.svg';
import CheckGrey from '../../../../images/common/check-hollow-grey.svg';
import CheckBlue from '../../../../images/common/check-hollow-blue.svg';
import ItemsIcon from '../../../../images/common/item-grey.svg';
import PeriodicIcon from '../../../../images/common/periodic-grey.svg';
import ClockIcon from '../../../../images/common/clock-grey.svg';
import AddIcon from '../../../../images/common/add-inside-circle.svg';
import CrossBlue from '../../../../images/products/cross-blue.svg';
import { CustomLabel, FilterGroups, FlexContainer, SelectedFilter, TableHeaderWrapper } from '../styles';
import { UtilityMethods } from '../utils';

type IProps = {
  total: number;
  showFilter?: boolean;
  onToggleFilter?: () => void;
  title?: string;
};

const TableHeader: FC<IProps> = ({
  total,
  showFilter,
  title = 'Records'
  // , onToggleFilter
}) => {
  const filters = () => {
    if (!showFilter) return null;
    return (
      <>
        {/* Filter Groups */}
        <FlexContainer spacing={15} padding="15px 0px">
          <FilterGroups>
            Quick Filter
            <span>5</span>
          </FilterGroups>
          <FilterGroups>
            Quick Filter
            <span>0</span>
          </FilterGroups>
          <FilterGroups>
            Quick Filter
            <span>125</span>
          </FilterGroups>
        </FlexContainer>
        {/* Filter Section */}
        <FlexContainer spacing={20} className="filter-section">
          <div>
            <SelectedFilter>
              <img src={CheckBlue} />
              <CustomLabel>Type</CustomLabel>
              <CustomLabel>
                <span className="semi-bold">Active, Cancelled, Inactive</span>
              </CustomLabel>
              <img src={CrossBlue} className="cross-icon" />
            </SelectedFilter>
          </div>
          <div>
            <img src={CheckGrey} />
            <CustomLabel>Type</CustomLabel>
          </div>
          <div>
            <img src={ItemsIcon} />
            <CustomLabel>Items</CustomLabel>
          </div>
          <div>
            <img src={PeriodicIcon} />
            <CustomLabel>Paid to Date</CustomLabel>
          </div>
          <div>
            <img src={ClockIcon} />
            <CustomLabel>Last Order</CustomLabel>
          </div>
          <div>
            <img src={ClockIcon} />
            <CustomLabel>Created Date</CustomLabel>
          </div>
          <div>
            <img src={AddIcon} />
            <CustomLabel>Add</CustomLabel>
          </div>
        </FlexContainer>
      </>
    );
  };
  return (
    <TableHeaderWrapper>
      <FlexContainer alignItems="center" justifyContent="space-between">
        <div>
          <CustomLabel fontSize="20px" fontWeight="600">
            {title} <span className="text-green">{UtilityMethods.numberWithCommas(total)}</span>
          </CustomLabel>
        </div>
        <div>
          <FlexContainer spacing={30} className="filter-icons">
            <div
            // onClick={() => onToggleFilter && onToggleFilter()} className="clickable"
            >
              <img src={FilterIcon} />
              <CustomLabel
                fontSize="14px"
                // className="clickable"
              >
                Filters
              </CustomLabel>
            </div>
            <div>
              <img src={ColumnIcon} />
              <CustomLabel fontSize="14px">Columns</CustomLabel>
            </div>
            <div>
              <img src={ExportIcon} />
              <CustomLabel fontSize="14px">Export</CustomLabel>
            </div>
          </FlexContainer>
        </div>
      </FlexContainer>
      {filters()}
    </TableHeaderWrapper>
  );
};

export default TableHeader;
